!function (e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t(require("vue")) : "function" == typeof define && define.amd ? define("ComponentSidebar", ["vue"], t) : "object" == typeof exports ? exports.ComponentSidebar = t(require("vue")) : e.ComponentSidebar = t(e.Vue)
}(globalThis, (function (e) {
    return function () {
        var t = {
                447: function (e) {
                    e.exports = {
                        filename: "sidebar",
                        componentName: "i-sidebar",
                        library: "ComponentSidebar"
                    }
                },
                744: function (e, t) {
                    "use strict";
                    t.Z = (e, t) => {
                        const n = e.__vccOpts || e;
                        for (const [e, o] of t) n[e] = o;
                        return n
                    }
                },
                895: function (t) {
                    "use strict";
                    t.exports = e
                }
            },
            n = {};

        function o(e) {
            var i = n[e];
            if (void 0 !== i) return i.exports;
            var l = n[e] = {
                exports: {}
            };
            return t[e](l, l.exports, o), l.exports
        }

        o.n = function (e) {
            var t = e && e.__esModule ? function () {
                return e.default
            } : function () {
                return e
            };
            return o.d(t, {
                a: t
            }), t
        }, o.d = function (e, t) {
            for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            })
        }, o.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        }, o.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            })
        };
        var i = {};
        return function () {
            "use strict";
            o.r(i), o.d(i, {
                default: function () {
                    return E
                }
            });
            var e = o(895),
                t = {
                    class: "i-sidebar"
                },
                n = {
                    class: "i-sidebar-main"
                },
                l = {
                    class: "i-sidebar-main-menu"
                },
                r = {
                    class: "ivu-menu ivu-menu-light ivu-menu-vertical"
                },
                a = {
                    key: 0,
                    class: "i-sidebar-main-extend"
                },
                c = {
                    key: 0,
                    class: "i-sidebar-main-extend-search"
                },
                d = {
                    class: "i-sidebar-main-extend-menu-group"
                },
                u = ["id"],
                s = {
                    class: "i-sidebar-main-extend-nav"
                },
                m = ["onClick"];
            var p = {
                class: "i-sidebar-item"
            };
            var h = {
                    class: "i-layout-menu-side-title"
                },
                f = ["src"];
            var g = {
                    name: "iMenuSideTitle",
                    mixins: [{
                        methods: {
                            tTitle: function (e) {
                                return e && 0 === e.indexOf("$t:") ? this.$t(e.split("$t:")[1]) : e
                            }
                        }
                    }],
                    props: {
                        menu: {
                            type: Object,
                            default: function () {
                                return {}
                            }
                        },
                        hideTitle: {
                            type: Boolean,
                            default: !1
                        },
                        selected: {
                            type: Boolean,
                            default: !1
                        }
                    }
                },
                x = o(744);
            var k = (0, x.Z)(g, [
                ["render", function (t, n, o, i, l, r) {
                    var a = (0, e.resolveComponent)("Icon");
                    return (0, e.openBlock)(), (0, e.createElementBlock)("span", h, [o.menu.icon || o.menu.custom || o.menu.img ? ((0, e.openBlock)(), (0, e.createElementBlock)("span", {
                        key: 0,
                        class: (0, e.normalizeClass)(["i-layout-menu-side-title-icon", {
                            "i-layout-menu-side-title-icon-single": o.hideTitle
                        }])
                    }, [o.menu.icon ? ((0, e.openBlock)(), (0, e.createBlock)(a, {
                        key: 0,
                        type: o.menu.icon
                    }, null, 8, ["type"])) : o.menu.custom ? ((0, e.openBlock)(), (0, e.createBlock)(a, {
                        key: 1,
                        custom: o.menu.custom
                    }, null, 8, ["custom"])) : o.menu.img ? ((0, e.openBlock)(), (0, e.createElementBlock)("img", {
                        key: 2,
                        src: o.menu.img
                    }, null, 8, f)) : (0, e.createCommentVNode)("", !0)], 2)) : (0, e.createCommentVNode)("", !0), o.hideTitle ? (0, e.createCommentVNode)("", !0) : ((0, e.openBlock)(), (0, e.createElementBlock)("span", {
                        key: 1,
                        class: (0, e.normalizeClass)(["i-layout-menu-side-title-text", {
                            "i-layout-menu-side-title-text-selected": o.selected
                        }])
                    }, (0, e.toDisplayString)(t.tTitle(o.menu.title)), 3))])
                }]
            ]);
            var y = {
                name: "i-sidebar-item",
                components: {
                    iMenuSideTitle: k
                },
                emits: ["on-sidebar-item-click", "on-sidebar-extend"],
                props: {
                    title: {
                        type: String,
                        default: ""
                    },
                    name:{
                        type:String,
                        default:""
                    },
                    icon: {
                        type: String,
                        default: ""
                    },
                    custom: {
                        type: String,
                        default: ""
                    },
                    img: {
                        type: String,
                        default: ""
                    },
                    selected: {
                        type: Boolean,
                        default: !1
                    },
                    path: {
                        type: String
                    },
                    replace: {
                        type: Boolean,
                        default: !1
                    },
                    target: {
                        type: String,
                        validator: function (e) {
                            return function (e, t) {
                                for (var n = 0; n < t.length; n++)
                                    if (e === t[n]) return !0;
                                return !1
                            }(e, ["_blank", "_self", "_parent", "_top"])
                        },
                        default: "_self"
                    },
                    extensible: {
                        type: Boolean,
                        default: !1
                    }
                },
                computed: {
                    menu: function () {
                        return {
                            icon: this.icon,
                            custom: this.custom,
                            img: this.img,
                            title: this.title
                        }
                    }
                },
                methods: {
                    handleClick: function (e) {
                        this.$emit("on-sidebar-item-click", e)
                    },
                    handleExtend: function () {
                        this.$emit("on-sidebar-extend")
                    }
                }
            };
            var v = {
                name: "i-sidebar",
                components: {
                    iSidebarItem: (0, x.Z)(y, [
                        ["render", function (t, n, o, i, l, r) {
                            var a = (0, e.resolveComponent)("i-menu-side-title"),
                                c = (0, e.resolveComponent)("Icon"),
                                menuItem = (0, e.resolveComponent)("MenuItem"),
                                menu = (0, e.resolveComponent)("Menu");
                            return (0, e.openBlock)(), (0, e.createElementBlock)("div", p, [(0, e.createVNode)(menu, null, {
                                default: (0, e.withCtx)((function () {
                                    return [o.extensible ? ((0, e.openBlock)(), (0, e.createBlock)(menuItem, {
                                        key: 0,
                                        onClick: r.handleExtend,
                                        name: "extend"
                                    }, {
                                        default: (0, e.withCtx)((function () {
                                            return [(0, e.createVNode)(a, {
                                                menu: r.menu
                                            }, null, 8, ["menu"]), (0, e.createVNode)(c, {
                                                type: "ios-arrow-forward",
                                                class: "i-sidebar-item-arrow"
                                            })]
                                        })),
                                        _: 1
                                    }, 8, ["onClick"])) : ((0, e.openBlock)(), (0, e.createBlock)(menuItem, {
                                        key: 1,
                                        to: o.path,
                                        replace: o.replace,
                                        target: o.target,
                                        name: o.name,
                                        onClick: n[0] || (n[0] = function (e) {
                                            return r.handleClick(r.menu.path)
                                        })
                                    }, {
                                        default: (0, e.withCtx)((function () {
                                            return [(0, e.createVNode)(a, {
                                                menu: r.menu,
                                                selected: o.selected
                                            }, null, 8, ["menu", "selected"])]
                                        })),
                                        _: 1
                                    }, 8, ["to", "replace", "target", "name"]))]
                                })),
                                _: 1
                            })])
                        }]
                    ]),
                    iMenuSideTitle: k
                },
                emits: ["on-search"],
                props: {
                    menuList: {
                        type: Array,
                        default: function () {
                            return []
                        }
                    },
                    extend: {
                        type: Boolean,
                        default: !1
                    },
                    extendIcon: {
                        type: String,
                        default: ""
                    },
                    extendCustom: {
                        type: String,
                        default: ""
                    },
                    extendImg: {
                        type: String,
                        default: ""
                    },
                    extendTitle: {
                        type: String,
                        default: ""
                    },
                    extendSearch: {
                        type: Boolean,
                        default: !1
                    },
                    extendSearchPlaceholder: {
                        type: String,
                        default: "请输入关键词"
                    },
                    extendNav: {
                        type: Boolean,
                        default: !1
                    },
                    extendMenuList: {
                        type: Array,
                        default: function () {
                            return []
                        }
                    }
                },
                data: function () {
                    return {
                        showMenu: !true,
                        maskStyle: {
                            top: "48px"
                        },
                        isExtend: true,
                        // isExtend: !true,
                        query: "",
                        navIdPrefix: "i-sidebar-nav-",
                        highlightNavIndex: null
                    }
                },
                computed: {
                    drawerWidth: function () {
                        return this.isExtend ? 80 : 240
                    }
                },
                methods: {
                    handleToggleOpen: function () {
                        // this.showMenu = !this.showMenu, this.showMenu && (this.isExtend = true)
                        this.showMenu = !this.showMenu
                    },
                    handleClickItem: function () {
                        this.showMenu = !1
                    },
                    handleExtend: function () {
                        this.isExtend = !this.isExtend, this.highlightNavIndex = null
                    },
                    handleScrollToNav: function (e) {
                        var t = document.getElementById(this.navIdPrefix + e);
                        this.highlightNavIndex = e, this.$ScrollTop(this.$refs.extendMenu, {
                            to: t.offsetTop,
                            time: 500
                        })
                    },
                    handleSearch: function () {
                        this.$emit("on-search", this.query)
                    },
                    handleClose: function () {
                        this.highlightNavIndex = null
                    }
                }
            };
            const b = (0, x.Z)(v, [
                ["render", function (o, i, p, h, f, g) {
                    var x = (0, e.resolveComponent)("Icon"),
                        iSidebarItem = (0, e.resolveComponent)("i-sidebar-item"),
                        y = (0, e.resolveComponent)("Divider"),
                        v = (0, e.resolveComponent)("Input"),
                        b = (0, e.resolveComponent)("i-menu-side-title"),
                        C = (0, e.resolveComponent)("i-link"),
                        B = (0, e.resolveComponent)("Col"),
                        S = (0, e.resolveComponent)("Row"),
                        N = (0, e.resolveComponent)("Drawer");
                    return (0, e.openBlock)(), (0, e.createElementBlock)("div", t, [(0, e.createElementVNode)("div", {
                        class: "i-sidebar-btn i-layout-header-trigger i-layout-header-trigger-min",
                        onClick: i[0] || (i[0] = function () {
                            return g.handleToggleOpen && g.handleToggleOpen.apply(g, arguments)
                        })
                    }, [(0, e.renderSlot)(o.$slots, "trigger", {}, (function () {

                        return [(0, e.createVNode)(x, {
                            type: f.showMenu?"ios-apps":"md-apps",
                            size: "18",
                            color:f.showMenu?'#2d8cf0':''
                        })]
                    }))]), (0, e.createVNode)(N, {
                        modelValue: f.showMenu,
                        "onUpdate:modelValue": i[2] || (i[2] = function (e) {
                            return f.showMenu = e
                        }),
                        width: g.drawerWidth,
                        placement: "left",
                        "class-name": "i-sidebar-drawer",
                        "mask-style": f.maskStyle,
                        closable: f.isExtend,
                        onOnClose: g.handleClose
                    }, {
                        default: (0, e.withCtx)((function () {
                            return [(0, e.createElementVNode)("div", n, [(0, e.createElementVNode)("div", l, [(0, e.createElementVNode)("ul", r, [p.extend ? ((0, e.openBlock)(), (0, e.createElementBlock)(e.Fragment, {
                                key: 0
                            }, [(0, e.createVNode)(iSidebarItem, {
                                name:p.name,
                                icon: p.extendIcon,
                                custom: p.extendCustom,
                                img: p.extendImg,
                                title: p.extendTitle,
                                extensible: "",
                                onOnSidebarExtend: g.handleExtend
                            }, null, 8, ["icon", "custom", "img", "title", "onOnSidebarExtend"]), (0, e.createVNode)(y, {
                                class: "i-sidebar-main-divider"
                            })], 48)) : (0, e.createCommentVNode)("", !0), ((0, e.openBlock)(!0), (0, e.createElementBlock)(e.Fragment, null, (0, e.renderList)(p.menuList, (function (t, n) {
                                return (0, e.openBlock)(), (0, e.createBlock)(iSidebarItem, {
                                    key: n,
                                    title: t.title || t.meta.title,
                                    icon: t.icon || t.meta.icon,
                                    custom: t.custom,
                                    img: t.img,
                                    selected: t.selected,
                                    name: t.name,
                                    path: t.path,
                                    replace: t.replace,
                                    target: t.target,
                                    onOnSidebarItemClick: g.handleClickItem
                                }, null, 8, ["title", "icon", "custom", "img", "selected", "name", "path", "replace", "target", "onOnSidebarItemClick"])
                            })), 128))])]), f.isExtend ? ((0, e.openBlock)(), (0, e.createElementBlock)("div", a, [(0, e.createVNode)(S, {
                                class: "i-sidebar-main-extend-row"
                            }, {
                                default: (0, e.withCtx)((function () {
                                    return [(0, e.createVNode)(B, {
                                        class: "i-sidebar-main-extend-col",
                                        span: p.extendNav ? 18 : 24
                                    }, {
                                        default: (0, e.withCtx)((function () {
                                            return [p.extendSearch ? ((0, e.openBlock)(), (0, e.createElementBlock)("div", c, [(0, e.createVNode)(v, {
                                                modelValue: f.query,
                                                "onUpdate:modelValue": i[1] || (i[1] = function (e) {
                                                    return f.query = e
                                                }),
                                                search: "",
                                                placeholder: p.extendSearchPlaceholder,
                                                onOnSearch: g.handleSearch
                                            }, null, 8, ["modelValue", "placeholder", "onOnSearch"])])) : (0, e.createCommentVNode)("", !0), (0, e.createElementVNode)("div", {
                                                class: (0, e.normalizeClass)(["i-sidebar-main-extend-menu", {
                                                    "i-sidebar-main-extend-menu-without-search": !p.extendSearch
                                                }]),
                                                ref: "extendMenu"
                                            }, [(0, e.createElementVNode)("div", d, [((0, e.openBlock)(!0), (0, e.createElementBlock)(e.Fragment, null, (0, e.renderList)(p.extendMenuList, (function (t, n) {
                                                return (0, e.openBlock)(), (0, e.createElementBlock)("div", {
                                                    key: n,
                                                    class: "i-sidebar-main-extend-menu-group-list"
                                                }, [(0, e.createElementVNode)("h4", {
                                                    id: f.navIdPrefix + n,
                                                    class: (0, e.normalizeClass)({
                                                        "i-sidebar-main-extend-menu-group-highlight": f.highlightNavIndex === n
                                                    })
                                                }, [(0, e.createVNode)(b, {
                                                    menu: {
                                                        // icon: t.icon,
                                                        custom: t.custom,
                                                        img: t.img,
                                                        title: t.title
                                                    }
                                                }, null, 8, ["menu"])], 10, u), ((0, e.openBlock)(!0), (0, e.createElementBlock)(e.Fragment, null, (0, e.renderList)(t.children, (function (t, n) {
                                                    return (0, e.openBlock)(), (0, e.createBlock)(C, {
                                                        key: n,
                                                        onClick: g.handleClickItem,
                                                        to: t.children?t.children[0].path:t.path,
                                                        target: t.target
                                                    }, {
                                                        default: (0, e.withCtx)((function () {
                                                            return [(0, e.createVNode)(b, {
                                                                menu: {
                                                                    // icon: t.icon,
                                                                    custom: t.custom,
                                                                    img: t.img,
                                                                    title: t.title
                                                                }
                                                            }, null, 8, ["menu"])]
                                                        })),
                                                        _: 2
                                                    }, 1032, ["onClick", "to", "target"])
                                                })), 128))])
                                            })), 128))])], 2)]
                                        })),
                                        _: 1
                                    }, 8, ["span"]), p.extendNav ? ((0, e.openBlock)(), (0, e.createBlock)(B, {
                                        key: 0,
                                        class: "i-sidebar-main-extend-col",
                                        span: "6"
                                    }, {
                                        default: (0, e.withCtx)((function () {
                                            return [(0, e.createElementVNode)("div", s, [(0, e.createElementVNode)("ul", null, [((0, e.openBlock)(!0), (0, e.createElementBlock)(e.Fragment, null, (0, e.renderList)(p.extendMenuList, (function (t, n) {
                                                return (0, e.openBlock)(), (0, e.createElementBlock)("li", {
                                                    key: n,
                                                    onClick: function (e) {
                                                        return g.handleScrollToNav(n)
                                                    }
                                                }, (0, e.toDisplayString)(t.title), 9, m)
                                            })), 128))])])]
                                        })),
                                        _: 1
                                    })) : (0, e.createCommentVNode)("", !0)]
                                })),
                                _: 1
                            })])) : (0, e.createCommentVNode)("", !0)])]
                        })),
                        _: 1
                    }, 8, ["modelValue", "width", "mask-style", "closable", "onOnClose"])])
                }]
            ]);
            var C = b,
                B = o(447),
                S = o.n(B),
                N = {
                    Component: C
                },
                E = Object.assign(N, {
                    install: function (e) {
                        e.component(S()
                            .componentName, C)
                    }
                })
        }(), i
    }()
}));
//# sourceMappingURL=sidebar.min.js.map
